const globalJs = {
	elements: {},

	setHeaderBlocksHeight() {
		const mastheadHeight = document.querySelector('[data-masthead]').getBoundingClientRect().height

		const wpAdminBar = document.getElementById('wpadminbar')
		const adminbarHeight = wpAdminBar ? wpAdminBar.getBoundingClientRect().height : 0

		const aimmsSupportMenu = document.querySelector('.aimms-support-menu')
		const aimmsSupportMenuHeight = aimmsSupportMenu ? aimmsSupportMenu.getBoundingClientRect().height : 0

		const alertBanner = document.querySelector('[data-alert-banner]')
		const alertBannerHeight = alertBanner ? alertBanner.getBoundingClientRect().height : 0

		const height = mastheadHeight + adminbarHeight + aimmsSupportMenuHeight // I think this is part of the mastheadHeight + alertBannerHeight

		document.body.style.setProperty('--masthead-blocks-height', `${height}px`)
	},

	showAccordionItem: function (accordionItemName) {
		var query = window.location.search

		if (query && query.indexOf('show-element') !== -1) {
			query = query.replace('?show-element=', '')
			var element = document.querySelector('[data-show-element="' + query + '"]')
			var rect = element.getBoundingClientRect()

			element.click()

			window.scrollTo({
				top: rect.y,
				left: 0,
				behavior: 'smooth',
			})
		}
	},

	addClassToDemoFormLinks: function () {
		const demoFormLinks = document.querySelectorAll('a[href*="#demo-form"]')
		if (demoFormLinks) {
			Array.prototype.forEach.call(demoFormLinks, (element) => {
				element.classList.add('demo-form-hash-link')
			})
		}
	},

	init: function () {
		this.showAccordionItem(window.location.hash)
		this.addClassToDemoFormLinks()

		this.setHeaderBlocksHeight()
		window.addEventListener('resize', this.setHeaderBlocksHeight)
		window.addEventListener('AlertBannerToggle', () => {
			// Run it
			this.setHeaderBlocksHeight()
			// Then again, to account for the Alert Bar animating in height
			setTimeout(() => {
				this.setHeaderBlocksHeight()
			}, 500)
		})
	},
}

export default globalJs
